export default "__VITE_ASSET__aee32ad5__"